import { useNavigate } from 'react-router-dom';

// Estilos
import styles from './errorpage.module.css';

function ErrorPage() {
    const navigate = useNavigate();

    const handleVoltar = () => {
        navigate(-1);
    };

    return (
        <div className={styles.errorContainer}>
            <h1 className={styles.title}>Erro 404</h1>

            <p className={styles.subtitle}>Página não encontrada.</p>
            <p className={styles.message}>A URL acessada não foi identificada.</p>

            <p className={styles.homeLink} onClick={handleVoltar}>
                Voltar
            </p>
        </div>
    );
}

export default ErrorPage;